import _extends from 'babel-runtime/helpers/extends';
import { stepModel } from '../step/step-model';

function isCard(step) {
  return step.type === 'card';
}

function isVocabularyStep(step) {
  if (!isCard(step) || !stepModel.isCarouselStep(step)) {
    return false;
  }
  return !isExplanationStep(step);
}

function getVocabularyItemsCount(step) {
  var vocabItemsCount = 0;
  if (stepModel.isCarouselStep(step)) {
    var flatCarousel = step.content[0].carousel.flat();
    flatCarousel.forEach(function (carouselItem) {
      if (carouselItem.type === 'word') {
        vocabItemsCount++;
      }
    });
  }
  return vocabItemsCount;
}

function isExplanationStep(step) {
  if (!isCard(step)) {
    return false;
  }
  // If this is an Explanation step then every section should have
  //  a 'usage' item.  Inspect the first section and if there are no
  //  'usage' items then it is not an Explanation step.
  var hasUsageItem = false;
  var firstCarouselSection = stepModel.getCarouselSection(step, 0);
  if (Array.isArray(firstCarouselSection)) {
    hasUsageItem = firstCarouselSection.some(function (item) {
      return item.type === 'usage';
    });
  }
  return hasUsageItem;
}

function getExplanationsCount(step) {
  var explanationsCount = 0;
  if (stepModel.isCarouselStep(step)) {
    var flatCarousel = step.content[0].carousel.flat();
    flatCarousel.forEach(function (carouselItem) {
      if (carouselItem.type === 'usage') {
        explanationsCount++;
      }
    });
  }
  return explanationsCount;
}

var isCardOverlayImage = function isCardOverlayImage(step) {
  if (step && step.content && step.content.length > 0 && step.content[0].additionalContent) {
    return step.content[0].additionalContent.some(function (item) {
      return item.type === 'overlayImage';
    });
  }
  return false;
};

var hasAudio = function hasAudio(stepData) {
  if (!stepData) {
    return false;
  }
  return !!stepData.audio;
};

var hasVideo = function hasVideo(stepData) {
  if (!stepData) {
    return false;
  }
  var video = stepData.video,
      _stepData$pronunciati = stepData.pronunciationRule,
      pronunciationRule = _stepData$pronunciati === undefined ? [] : _stepData$pronunciati;

  return !!video || !!(pronunciationRule.length && pronunciationRule[0].videos);
};

var isReviewOnly = function isReviewOnly(step, stepData) {
  if (isDocumentStep(step) || isCardOverlayImage(step)) {
    return true;
  }
  return !hasAudio(stepData) && !hasVideo(stepData);
};

// soon to be obsolete:
function parseCardOverlayImage(step) {
  var imageArray = [];
  if (step.content[0].additionalContent.length > 0) {
    imageArray = step.content[0].additionalContent[0].overlayImages;
  }
  return {
    overlayImages: imageArray
  };
}

// transmuteAdditionalContent() takes the additionalContent object
//  and returns a map of the additionalContent members, keyed by their "type" member.
//  The `listTypes` arg allows caller to specify which content types should
//  be returned as an array
function transmuteAdditionalContent(additionalContent) {
  var listTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return additionalContent.reduce(function (result, item) {
    if (listTypes.includes(item.type)) {
      if (!result[item.type]) {
        result[item.type] = [];
      }
      result[item.type].push(item);
    } else {
      result[item.type] = item;
    }
    return result;
  }, {});
}

// Parse and store content data, for use in 'withStepData'
var parseCardData = function parseCardData(step) {
  if (isExplanationStep(step)) {
    return parseExplanationStep(step);
  }
  if (isVocabularyStep(step)) {
    return parseVocabularyStep(step);
  }
  // soon to be obsolete:
  if (isCardOverlayImage(step)) {
    return parseCardOverlayImage(step);
  }
  return parseCardStandard(step);
};

// Vocabulary card type parser
function parseVocabularyStep(step) {
  var content = step.content[0];
  var data = {
    carousel: content.carousel
  };
  return data;
}

var parseExplanationStep = function parseExplanationStep(step) {
  var content = step.content[0];
  var data = {
    carousel: content.carousel
  };
  return data;
};

function isDocumentStep(step) {
  return step.type === 'document';
}

function parseDocument(step) {
  var docHeading = step.content.find(function (contentItem) {
    return contentItem.type === 'text';
  });
  var docPages = [];
  step.content.forEach(function (contentItem) {
    if (contentItem.type === 'image') {
      docPages.push(contentItem);
    }
  });
  return {
    heading: docHeading,
    pages: docPages
  };
}

// Parses standard cards, without vocabulary or pronunciation samples data
function parseCardStandard(step) {
  var content = step.content[0];
  var additionalContent = transmuteAdditionalContent(content.additionalContent, ['context', 'pronunciationRule']);

  return _extends({}, additionalContent, {
    term: content.term
  });
}

export var stepCardModel = {
  isCard: isCard,
  isExplanationStep: isExplanationStep,
  getExplanationsCount: getExplanationsCount,
  isVocabularyStep: isVocabularyStep,
  getVocabularyItemsCount: getVocabularyItemsCount,
  isCardOverlayImage: isCardOverlayImage,
  hasAudio: hasAudio,
  hasVideo: hasVideo,
  isReviewOnly: isReviewOnly,
  transmuteAdditionalContent: transmuteAdditionalContent,
  parseCardData: parseCardData,
  isDocumentStep: isDocumentStep,
  parseDocument: parseDocument
};